import {CartComparator} from './cart-comparator';

interface CartItemSpecificationInterface extends CartComparator<CartItemSpecificationInterface> {
  optionId: string;
  specId: string;
  value: string;
  name?: string;
}

class CartItemSpecification implements CartItemSpecificationInterface {
  optionId: string;
  specId: string;
  value: string;
  name?: string;

  constructor(src?: {
    optionId: string;
    specId: string;
    value?: string;
    name?: string;
  }) {
    if (!src) return;

    this.optionId = src.optionId;
    this.specId = src.specId;
    this.value = src.value || '';
    this.name = src.name;
  }

  equals(
    a: CartItemSpecificationInterface,
    b: CartItemSpecificationInterface = this,
  ): boolean {
    return a === b || (a.optionId === b.optionId && a.specId === b.specId);
  }
}

export {CartItemSpecification, CartItemSpecificationInterface};
